/* eslint-disable no-console */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { UPDATE_GOOGLE_RECAPTCHA_TOKEN } from './GoogleRecaptcha.action';

export const initialState = {
    recaptchaToken: ''
};

/** @namespace Pwa/Store/GoogleRecaptcha/Reducer/GoogleRecaptchaReducer */
export const GoogleRecaptchaReducer = (state = initialState, action) => {
    const {
        type,
        recaptchaToken
    } = action;

    switch (type) {
    case UPDATE_GOOGLE_RECAPTCHA_TOKEN:

        return {
            ...state,
            recaptchaToken
        };

    default:
        return state;
    }
};

export default GoogleRecaptchaReducer;
